// extracted by mini-css-extract-plugin
export var arrows = "_5g-5";
export var decrementer = "_5g-9";
export var disabled = "_5g-3";
export var error = "_5g-1";
export var hiddenText = "_5g-a";
export var incrementer = "_5g-8";
export var input = "_5g-7";
export var inputWrapper = "_5g-0";
export var leadingIcon = "_5g-b";
export var readonly = "_5g-2";
export var regular = "_5g-6";
export var small = "_5g-4";